import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack5'

// This is needed to load the worker that will render the PDF
// details - config/webpack.config.common.js:150
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`

export { Document, Page }
